import {DocumentUIField} from '@/engine';
import {MetaField} from './meta-field';

type UIFieldProps = {
  field: DocumentUIField;
};

export const UIField = ({field}: UIFieldProps) => {
  return <MetaField field={field} />;
};
